import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesGastos() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "", items: [
      { label: "Conceptos", icon: "far fa-list-alt", color: "#d97706", href: "/ConceptosGastos", enabled: !!(user.menu_admin && user.menu_gastos) },
      { label: "Gastos", icon: "fas fa-receipt", color: "#d97706", href: "/Gastos", enabled: !!(user.menu_admin && user.menu_gastos) },
      { label: "Pagos Gastos", icon: "fas fa-dollar-sign", color: "#d97706", href: "/ListadoPagosGastos", enabled: !!(user.menu_admin && user.menu_gastos) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Gastos"
      descripcion="Conceptos, gastos y pagos"
      icono="fas fa-receipt"
      color="#d97706"
      secciones={secciones}
    />
  );
}

export default BotonesGastos;
